import React, { Component } from 'react'
import { observer } from 'mobx-react'
import classNames from 'classnames'
import { get } from 'utils/lodash.utils'
import withStyles from 'react-jss'

import { COURSE_BANNER_CLASS_NAMES } from '@elo-kit/constants/customCss.constants'
import courseBannerStyles from './courseBannerStyles'
import LessonsNavigation from '../lessons-navigation/LessonsNavigation'
import CustomPageNavigation from '../page-navigation/CustomPageNavigation'
import CustomButton from '../custom-button/CustomButton'

@observer
class CourseBanner extends Component {
  render() {
    const {
      courseRefreshAppActive,
      courseViewsStore,
      classes,
      shopName,
      toggleConfirmationModal,
      historyPush,
      desktopResolution,
      contentPageStore,
    } = this.props
    const {
      activeLesson,
      courseThemeData: { prefs = {} },
      product,
      isOverviewPage,
      sharingToken,
    } = courseViewsStore
    const showNavigationButtons = !isOverviewPage && prefs?.topNavigationEnabled
    const showLessonName = get(prefs, 'showLessonBannerText', true)
    const showCourseName = get(prefs, 'showOverviewBannerText', true)

    const navigationProps = {
      courseRefreshAppActive,
      toggleConfirmationModal,
      noPaddings: true,
    }

    return (
      <div className={classNames(COURSE_BANNER_CLASS_NAMES.containerClassName, classes.bannerContainer)}>
        <div className={classes.bannerOverlay} />
        <div className={classes.banner}>
          <div className={classNames(COURSE_BANNER_CLASS_NAMES.infoContainerClassName, classes.bannerInfoContainer)}>
            <CustomPageNavigation {...navigationProps} courseViewsStore={courseViewsStore} />
            <div className={shopName && classes.titleAndBuyBtn}>
              <div className={classes.title}>
                {isOverviewPage
                  ? showCourseName && product.name
                  : showLessonName && (activeLesson.name || I18n.t('react.shared.lesson_title'))}
              </div>
              {shopName && !sharingToken && (
                <CustomButton onClick={() => historyPush(`/s/${shopName}/${product.slug}/payment`)}>
                  {product.free
                    ? I18n.t('react.shared.button.take_for_free')
                    : I18n.t('react.shared.button.go_to_checkout')}
                </CustomButton>
              )}
            </div>
            {showNavigationButtons && (
              <LessonsNavigation
                {...navigationProps}
                desktopResolution={desktopResolution}
                courseViewsStore={courseViewsStore}
                contentPageStore={contentPageStore}
              />
            )}
          </div>
        </div>
      </div>
    )
  }
}

export default withStyles(courseBannerStyles)(CourseBanner)
